import { CmsLandingPage } from '../../models/cms/cms-landing-page.interface';
import { mockCmsGuestCheckout } from './cms-guest-checkout.mock';
import { mockCmsSignIn } from './cms-sign-in.mock';

export const mockCmsLandingPage: CmsLandingPage = {
  ...mockCmsGuestCheckout,
  ...mockCmsSignIn,
  pageTitle: 'pageTitle',
};
